<div class="h-full w-full relative bg-white border border-(--p-blue-50) rounded-[0.5rem] flex flex-col overflow-hidden">
  <div floating-popup-header class="h-[2.625rem] py-3 pr-3 pl-4 flex items-center justify-between">
    <div class="flex items-center gap-2 min-w-0">
      <span class="text-(--p-gray-950) font-bold truncate text-xs uppercase tracking-wide min-w-0">{{ popup().shortTitle | async }}</span>

      @if (popup().titleInfo | async; as titleInfo) {
        <div class="self-center h-[0.625rem] min-w-[1px] w-[1px] bg-(--p-primary-100) shrink-0"></div>
        <span class="text-(--p-gray-950) font-[500] text-[0.6875rem] uppercase tracking-wide shrink-0 whitespace-nowrap">{{ titleInfo }}</span>
      }
    </div>

    <gc-floating-popup-minimized-header-actions [popup]="popup()" />
  </div>

  <div class="flex flex-col h-full overflow-auto relative">
    @let isNoDataError = !selectedData() && initialized();

    @if (isNoDataError) {
    <div class="grow-1 items-center justify-center min-h-[6.25rem] flex flex-col px-[0.75rem] sm:px-[1rem]">
      <gc-floating-popup-base-error-message [isMinimized]="true"></gc-floating-popup-base-error-message>
    </div>
  } @else {
    @let tabConnectService = activeTabConnectService();
  
    @if (tabConnectService) {
      <ng-container *ngComponentOutlet="tabConnectService.minimizedComponent; inputs: { popup: popup() }"></ng-container>
    } @else {
      <div class="flex items-center justify-center flex-1 w-full px-5 relative text-(--p-gray-500)">
        This is not implemented yet! Correlation ID: {{data.correlation.id}}<br>
        Selected tab key: {{selectedTab()}}<br>
        Need to add content in future for this tab
      </div>
    }
  }
    

    @let isMainLoading = loading();
    @let isActiveTabLoading = activeTabLoading();

    @if (isMainLoading || isActiveTabLoading) {
      <div class="absolute inset-0 z-content-overlay-20">
        <gc-spinner></gc-spinner>
      </div>
    }
  </div>
</div>